import { render, staticRenderFns } from "./RecycleTypeBeforeSelectionChartLegend.vue?vue&type=template&id=444f82ce&scoped=true"
import script from "./RecycleTypeBeforeSelectionChartLegend.vue?vue&type=script&lang=js"
export * from "./RecycleTypeBeforeSelectionChartLegend.vue?vue&type=script&lang=js"
import style0 from "./RecycleTypeBeforeSelectionChartLegend.vue?vue&type=style&index=0&id=444f82ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444f82ce",
  null
  
)

export default component.exports